
import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { ITimeZoneApi } from './base/timeZoneApi';
import { KeyValue } from '../models/common';
import { Result } from '../models/common/resultResponse';
import { timeZoneFilterRequest } from '../models/request/timeZone';

const baseRoute: string = 'TimeZone';

export class TimeZoneApi extends ITimeZoneApi {
  getDomain(request: timeZoneFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`, { params: request });
  }
}
